webpackJsonp([44304415692529],{

/***/ 666:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"slug":"inmigracion/1/1","node":{"sheet":"Inmigración","idbaraja":"1","baraja":"¿Cómo funcionan las visas en EEUU?","idcard":"1","card":"¿Qué es una visa? ","text":"<li> Una visa es <b>un sello estampado en un pasaporte</b> que indica la categoría de ingreso con la que el portador es autorizado a entrar al país bajo dos categorías: inmigrante o no inmigrante.</li><li> La visa sellada en un pasaporte no refleja el <b>período de tiempo autorizado al viajero al entrar en el territorio nacional</b>, y no tiene efecto en el estatus no inmigratorio del individuo en Estados Unidos.</li>","fuentes":"<b>Inmigración - Las nuevas reglas</b>","url":"https://www.univision.com/noticias/inmigracion/visas-para-estados-unidos","disclaimer":"<p>* Este no es un consejo legal. Antes de tomar cualquier decisión en materia migratoria, consulte con un abogado.</p>","urlfuente":"https://www.univision.com/noticias/inmigracion/nuevas-reglas-de-inmigracion"}}}

/***/ })

});


// WEBPACK FOOTER //
// path---inmigracion-1-1-01296e5d50d2b419b758.js